module.exports = "./img/ecf01be62eaa756c975dd7963de360e3.jpg";